export const optionsAreValid = (
  itemOptions: Array<{ _id: string; minQty?: number | null; maxQty?: number | null } | null> | null,
  selectedOptions: Record<string, Record<string, { qty: number; price: number }>>,
) => {
  if (!itemOptions) return true
  const optionsInvalid = itemOptions.some((option) => {
    if (!option) return false
    const selectedOptionCategory = selectedOptions[option._id]

    const totalSelected = selectedOptionCategory
    ? Object.values(selectedOptionCategory).reduce((total, val) => total + val.qty, 0)
    : 0

    if (
      (option.maxQty && totalSelected > option.maxQty) ||
      (option.minQty && totalSelected < option.minQty)
    ) return true
    
    return false
  })
  return !optionsInvalid
}
